// Phase 3 (Feb 2026): centralised tier helpers for the new 5-tier model.
// Use these everywhere instead of literal string comparisons so legacy
// values (`free`/`monthly`/`annual`/`lifetime`) are handled correctly
// during the migration window AND any future tier renames stay in one
// place.

export const FREE_TIERS = new Set(['open_play', 'instructor_starter', 'free']);

export const PAID_TIERS = new Set([
  'verified_player',
  'instructor_plus',
  'instructor_unlimited',
  // Legacy values — still paid in DB until migration completes.
  'monthly',
  'annual',
  'lifetime',
]);

export const TIER_LABELS = {
  open_play: 'Open Play',
  verified_player: 'Verified Player',
  instructor_starter: 'Instructor Starter',
  instructor_plus: 'Instructor Advantage',
  instructor_unlimited: 'Instructor Unlimited',
  // Legacy values displayed with a label so we don't show raw strings.
  free: 'Open Play',
  monthly: 'Verified Player (legacy)',
  annual: 'Verified Player (legacy)',
  lifetime: 'Instructor Unlimited (legacy)',
};

/** True if the user/tier is on a paid tier (or grandfathered lifetime). */
export function isPaidTier(userOrTier) {
  if (!userOrTier) return false;
  if (typeof userOrTier === 'string') return PAID_TIERS.has(userOrTier.toLowerCase());
  const tier = (userOrTier.subscription_tier || '').toLowerCase();
  if (userOrTier.legacy_lifetime) return true;
  if (userOrTier.role === 'admin') return true;
  return PAID_TIERS.has(tier);
}

/** Friendly display label for a tier string (handles legacy + falsy). */
export function tierLabel(tier) {
  const k = (tier || 'open_play').toLowerCase();
  return TIER_LABELS[k] || tier || 'Open Play';
}
